import { Component, Input, OnInit } from '@angular/core';
import { QuickCriteriaFilter } from '../../Criteria/quickCriteria.model';

interface QuickExtraDescriptor {
    label: string;
    value: any;
}

@Component({
    selector: 'search-result-extra',
    templateUrl: './searchResultExtra.component.html',
    standalone: false
})
export class SearchResultExtraComponent implements OnInit {
    @Input() result: any;
    @Input() filter: QuickCriteriaFilter;

    descriptors: QuickExtraDescriptor[] = [];
    resultField: string = '';

    ngOnInit(): void {
        if (this.isDescriptor()) {
            this.descriptors = this._getDescriptors();
        } else {
            this.resultField = this._getResultField();
        }
    }

    isDescriptor(): boolean {
        return this.filter.field === 'parcelDescriptor' || this.filter.field === 'siteDescriptor';
    }

    private _getResultField(): string {
        let value = '';

        switch (this.filter.field) {
            case 'parcelAddress':
                value += this.result.parcelAddress1 || '';
                if (this.result.parcelAddress2) {
                    value += `, ${  this.result.parcelAddress2}`;
                }

                return value;
            case 'siteAddress':
                value += this.result.siteAddress1 || '';
                if (this.result.siteAddress2) {
                    value += `, ${  this.result.siteAddress2}`;
                }

                return value;
            case 'parcelAssessor':
                value += this.result.parcelAssessorAbbr || '';
                if (this.result.parcelAssessorMunicipality) {
                    value += ` ${  this.result.parcelAssessorMunicipality}`;
                }

                return value;
            case 'siteAssessor':
                value += this.result.siteAssessorAbbr || '';
                if (this.result.siteAssessorMunicipality) {
                    value += ` ${  this.result.siteAssessorMunicipality}`;
                }

                return value;
            default:
                return this.result[this.filter.resultField] || '';
        }
    }

    private _getDescriptors(): QuickExtraDescriptor[] {
        return Object.keys(this.result)
            .filter(key => key.split('.')[0] === this.filter.field && this.result[key])
            .map(key => {
                return {
                    label: key.substring(key.indexOf('.') + 1),
                    value: this.result[key]
                }
            });
    }
}
